import type { ImageSizeType, ImageTypeName } from '@inter-ikea-kompis/core/types'

import type { ProductData } from '@sofa-platform/types'

export function getProductImage(productData: ProductData, size: ImageSizeType, typeName: ImageTypeName) {
  const img = productData.content.image?.find((img) => img.size === size && img.typeName === typeName)
  return { alt: img?.alternativeText, src: img?.url }
}
